// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wKdAFSx9EF1xdwOrxHuk {
    background-color: var(--color-primary-white);
    border-radius: 12px;
    margin: 0 auto;
    text-align: center;
    width: 100%;
    max-width: 28rem;
    padding: 1rem 1.5rem;
    box-sizing: border-box;
    padding-bottom: 0.75rem;
    border: 1px solid #dddddd;
}

.QNja2Q9mqWVYuinKG0Jl {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
}

.jrdxmGyyVBoBUlMAhJA5 {
    width: 1.6em;
    height: 1.6em;
    flex-shrink: 0;
    margin-right: 0.5rem;
}

._dYPEhUigpj_SVASg7Mm {
    width: 1.6em;
    height: 1.6em;
    filter: brightness(0) invert(1);
    margin-right: 0.5rem;
}

.gO5TWBIkFGt7n73LNFcA {
    height: 24px;
    width: auto;
    display: inline-block;
    margin-right: 0.75rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/EParakstsBox/EParakstsBox.module.css"],"names":[],"mappings":"AAAA;IACI,4CAA4C;IAC5C,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,oBAAoB;IACpB,sBAAsB;IACtB,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,+BAA+B;IAC/B,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,qBAAqB;IACrB,qBAAqB;AACzB","sourcesContent":[".epsBox {\n    background-color: var(--color-primary-white);\n    border-radius: 12px;\n    margin: 0 auto;\n    text-align: center;\n    width: 100%;\n    max-width: 28rem;\n    padding: 1rem 1.5rem;\n    box-sizing: border-box;\n    padding-bottom: 0.75rem;\n    border: 1px solid #dddddd;\n}\n\n.buttonContent {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.5rem;\n}\n\n.epsIcon {\n    width: 1.6em;\n    height: 1.6em;\n    flex-shrink: 0;\n    margin-right: 0.5rem;\n}\n\n.epsIconWhite {\n    width: 1.6em;\n    height: 1.6em;\n    filter: brightness(0) invert(1);\n    margin-right: 0.5rem;\n}\n\n.epsFullLogo {\n    height: 24px;\n    width: auto;\n    display: inline-block;\n    margin-right: 0.75rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"epsBox": `wKdAFSx9EF1xdwOrxHuk`,
	"buttonContent": `QNja2Q9mqWVYuinKG0Jl`,
	"epsIcon": `jrdxmGyyVBoBUlMAhJA5`,
	"epsIconWhite": `_dYPEhUigpj_SVASg7Mm`,
	"epsFullLogo": `gO5TWBIkFGt7n73LNFcA`
};
module.exports = ___CSS_LOADER_EXPORT___;
